import script from "./OutterCommodityExpalainListResult.vue?vue&type=script&setup=true&lang=js"
export * from "./OutterCommodityExpalainListResult.vue?vue&type=script&setup=true&lang=js"

import "./OutterCommodityExpalainListResult.vue?vue&type=style&index=0&id=5a7f26d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7f26d9"]])

export default __exports__